// Configuration for data source
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      REACT_APP_BACKEND_BASE_URL?: string;
      REACT_APP_SHOW_SAVED_SCREENSHOTS?: string;
      REACT_APP_SHOW_STATUS_SNACKBAR?: string;
      REACT_APP_CHARTS_DEBUG?: string;
    };
  }
}

const parseBool = (value: unknown): boolean | undefined => {
  if (value == null) return undefined;
  const raw = String(value).trim().toLowerCase();
  if (!raw) return undefined;
  if (['1', 'true', 'yes', 'y', 'on'].includes(raw)) return true;
  if (['0', 'false', 'no', 'n', 'off'].includes(raw)) return false;
  return undefined;
};

const runtimeShowSavedScreenshots =
  typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__?.REACT_APP_SHOW_SAVED_SCREENSHOTS : undefined;

const showSavedScreenshots =
  parseBool(runtimeShowSavedScreenshots ?? process.env.REACT_APP_SHOW_SAVED_SCREENSHOTS) ??
  true;

const runtimeShowStatusSnackbar =
  typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__?.REACT_APP_SHOW_STATUS_SNACKBAR : undefined;

// When false (default), the bottom-left snackbar is hidden and notifications are suppressed.
// Toggle at runtime (prod) via public/runtime-config.js without rebuilding.
const showStatusSnackbar =
  parseBool(runtimeShowStatusSnackbar ?? process.env.REACT_APP_SHOW_STATUS_SNACKBAR) ?? false;

export const config = {
  // API-only mode: never fall back to local JSON or mock data.
  // In production, all FMP/Fiscal calls go through the authenticated backend proxy.
  useRealAPI: true,

  // Console noise control
  // When true (and in development), suppress console.log/info/debug.
  // console.warn/error are still shown.
  console: {
    suppressLogs: true,
  },
  
  // API Configuration
  api: {
    baseUrl: 'https://financialmodelingprep.com/stable',
    // Client must use backend proxy; no API keys in the browser.
    apiKey: '',
    defaultSymbol: 'AAPL'
  },

  // Local backend (Admin/JWT)
  backend: {
    // CRA exposes only REACT_APP_* variables.
    // Example: REACT_APP_BACKEND_BASE_URL=http://localhost:5085
    // In production we typically host the API under the same origin at /api.
    // Defaulting to localhost in production causes "Failed to fetch" in the browser.
    // You can still override via window.__RUNTIME_CONFIG__ or REACT_APP_BACKEND_BASE_URL.
    baseUrl: (
      (typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__?.REACT_APP_BACKEND_BASE_URL : undefined) ??
      process.env.REACT_APP_BACKEND_BASE_URL ??
      (process.env.NODE_ENV === 'development' ? 'http://localhost:5085' : '/api')
    )
      .trim()
      .replace(/\/$/, ''),
  },

  features: {
    // Show "My Saved Screenshot" by default (including production).
    // Override via env/runtime with REACT_APP_SHOW_SAVED_SCREENSHOTS=false.
    showSavedScreenshots,
  },

  ui: {
    showStatusSnackbar,
  },
};
